<template>
    <Layout>
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="card overflow-hidden">
                    <div class="bg-soft-primary">
                        <div class="row">
                            <div class="col-7">
                                <div class="text-primary p-4">
                                    <h5 class="text-primary">Witamy!</h5>
                                    <p>Zaloguj się do panelu użytkownika z użyciem konta offline.</p>
                                </div>
                            </div>
                            <div class="col-5 align-self-end">
                                <img
                                    alt
                                    class="img-fluid"
                                    src="@/assets/images/profile-img.png"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div>
                            <router-link tag="a" to="/">
                                <div class="avatar-md profile-user-wid mb-4">
                                  <span class="avatar-title rounded-circle bg-light">
                                    <img alt height="34" src="@/assets/images/logo.svg"/>
                                  </span>
                                </div>
                            </router-link>
                        </div>
                        <b-alert
                            v-model="isAuthError"
                            class="mt-3"
                            dismissible
                            variant="danger"
                        >{{ authError }}
                        </b-alert
                        >

                        <div
                            v-if="notification.message"
                            :class="'alert ' + notification.type"
                        >
                            {{ notification.message }}
                        </div>

                        <b-form class="p-2" @submit.prevent="tryToLogIn">
                            <loader :active="loading" :bgColor="theme.themeColor2"/>
                            <success-animation v-if="successLogin" :delay="0"/>
                            <div v-else>
                                <b-form-group
                                    id="input-group-1"
                                    label="Email"
                                    label-for="input-1"
                                >
                                    <b-form-input
                                        id="input-1"
                                        v-model="email"
                                        :class="{ 'is-invalid': submitted && $v.email.$error }"
                                        placeholder="Wprowadź email"
                                        type="text"
                                    ></b-form-input>
                                    <div
                                        v-if="submitted && $v.email.$error"
                                        class="invalid-feedback"
                                    >
                                        <span v-if="!$v.email.required">Email jest wymagany.</span>
                                        <span v-if="!$v.email.email">Wprowadź poprawny adres email.</span>
                                    </div>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-2"
                                    label="Hasło"
                                    label-for="input-2"
                                >
                                    <b-form-input
                                        id="input-2"
                                        v-model="password"
                                        :class="{ 'is-invalid': submitted && $v.password.$error }"
                                        placeholder="Wprowadź hasło"
                                        type="password"
                                    ></b-form-input>
                                    <div
                                        v-if="submitted && !$v.password.required"
                                        class="invalid-feedback"
                                    >
                                        Hasło jest wymagane.
                                    </div>
                                </b-form-group>
                                <div class="mt-3">
                                    <b-button class="btn-block" type="submit" variant="primary">
                                        <i class="fa fa-sign-in-alt"></i>  Zaloguj się
                                    </b-button>
                                </div>
                            </div>
                        </b-form>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card -->

                <div class="mt-5 text-center">
                    <p>
                        Nie masz utworzonego konta offline?
                        <router-link
                            :to="{ name: 'loginToken'}"
                            class="font-weight-medium text-primary"
                            tag="a"
                        >
                            Użyj tokenu
                        </router-link>
                    </p>
                    <p>
                        © {{ new Date().getFullYear() }} {{ cfg.global.information.serverName }}. Made with
                        <i class="mdi mdi-heart text-danger"></i> by <a href="http://ro-bot.pl" target="_blank" class="robot">RO-BOT</a>
                    </p>
                </div>
                <!-- end row -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </Layout>
</template>

<script>
import Layout from "../../layouts/auth";
import {
    notificationMethods,
} from "@/state/helpers";

import {required, email} from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
    name: "LoginOffline",
    components: {
        Layout,
    },
    data() {
        return {
            loading: false,
            email: "",
            password: "",
            submitted: false,
            authError: null,
            tryingToLogIn: false,
            isAuthError: false,
            successLogin: false
        };
    },
    validations: {
        email: {
            required,
            email,
        },
        password: {
            required,
        },
    },
    computed: {
        notification() {
            return this.$store ? this.$store.state.notification : null;
        },
        theme() {
            return this.$store.getters['cfg/get'].global.theme;
        },
        cfg() {
            return this.$store.getters['cfg/get'];
        }
    },
    methods: {
        ...notificationMethods,
        // Try to log the user in with the username
        // and password they provided.
        tryToLogIn() {
            this.loading = true;
            this.submitted = true;

            // stop here if form is invalid
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.loading = false;
                return;
            } else {
                this.isAuthError = false;
                this.$store.dispatch('auth/loginOffline', {email: this.email, password: this.password}).then(
                    () => {
                        this.loading = false;
                        this.tryingToLogIn = false;
                        this.isAuthError = false;

                        this.successLogin = true;
                        setTimeout(() => {
                            let routerPush;

                            if (this.$route.query.redirectFrom) {
                                routerPush = {path: this.$route.query.redirectFrom, query: {logged: true, type: 'offline'}};
                            } else {
                                routerPush = {name: "default", query: {logged: true, typed: 'offline'}}
                            }

                            this.$router.push(routerPush);
                        }, 1500);
                    },
                    error => {
                        this.loading = false;
                        this.tryingToLogIn = false;
                        if (error && error.response && error.response.status && error.response.status === 401)
                            this.authError = "Niepoprawny email lub hasło";
                        else
                            this.authError = error ? error : "";
                        this.isAuthError = true;
                    }
                );
            }
        },
    },
    mounted() {
    },
};
</script>

<style lang="scss" module></style>
